import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import type { HistoryStateContract } from '@bcf2-shared-pkg-v1/ui/shared/bcf-router/history-state';
import { addBaseHrefToUrl } from '@tmf-shared-platform/router/router-utils';
import { Observable, Subject, map, startWith } from 'rxjs';

export class HistoryState implements HistoryStateContract {
  private _historyStateChanged$: Subject<void> = new Subject<void>();

  public getState(): Observable<Record<string, any>> {
    return this._historyStateChanged$.pipe(
      startWith(undefined),
      map(() => window.history.state)
    );
  }

  public updateState(url: string, newState: Record<string, any>): void {
    const mergedState: Record<string, any> = {
      ...window.history.state,
      ...newState
    };
    window.history.replaceState(mergedState, '', addBaseHrefToUrl(url));
    this._historyStateChanged$.next(undefined);
  }

  public mergeCurrentState(state: Record<string, any>): void {
    window.history.replaceState({ ...window.history.state, ...state }, '', window.location.href);
    this.stateMightChanged();
  }

  public stateMightChanged(): void {
    this._historyStateChanged$.next(undefined);
  }

  public back(): void {
    window.history.back();
  }

  public goBack(n: number): void {
    window.dispatchEvent(new CustomEvent('routerGoingBack', { detail: { count: n } }));
    window.history.go(n * -1);
    window.dispatchEvent(new Event('routerReplaced'));
  }
}

export function provideHistoryState(): HistoryState {
  return provideSingleton(HistoryState, () => new HistoryState());
}
